const colorPalette = [
    '#9068BE',
    '#E62739',
    '#845007',
    '#3A4660',
    '#1D1E22',
    '#BE7D6A',
    '#005995',
    '#600473',
    '#CD5554',
    '#00303F',
    '#BE4F0C',
    '#4ABDAC',
    '#FC4A1A',
    '#368CBF',
    '#7EBC59',
    '#201D3A',
    '#269CCC',
    '#737272',
    '#237107',
    '#52028E',
    '#AF0D74',
    '#6CB883',
    '#0DAFA4',
    '#A71515',
    '#157FA7',
    '#7E52B1',
    '#27956A',
    '#9A4B70',
    '#FBBE30',
    '#ED3533',
    '#571C8D',
    '#54181C',
    '#9B6700',
    '#6E8E14',
    '#0752A1',
    '#BF6421',
    '#00A59C',
    '#9F0190',
    '#AE3A3A',
    '#858102',
    '#027E02',
    '#F66E54'
  ];

 export const getColorForName = (name) => {
  let hash = 0;
  for (let i = 0; i < name?.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colorPalette?.length;
  return colorPalette[ index ];
};
